// @ts-nocheck
import { fabric } from 'fabric';
import _ from 'lodash';
import { addSVGs } from '@/shared/lib';
import { ANNOTATION_TYPE } from '../../config';
import AFibEvent from '../../lib/annotations/components/afibEvent';
import Pattern from '../../lib/annotations/components/pattern';
import SampleMark from '../../lib/annotations/components/sampleMark';

let EcgView;

(function () {
  EcgView = function (
    canvasChart: any,
    pixelSamples: any,
    config: any,
    displayedChannelsArr: any,
    verticalChannelPlacement: any,
  ) {
    this.canvasChart = canvasChart;
    this.pixelSamples = pixelSamples;
    this.displayedChannelsArr = displayedChannelsArr;
    this.config = config;
    this.verticalChannelPlacement = verticalChannelPlacement;
    this.ctxChart = this.canvasChart.getContext('2d');
    this.ctxChart.lineWidth = 1.1; // *: For draw
    this.lineWidthExport = 1.2; // *: For export
    this.sampleMarkColor = '#f80000';
    this.patternColor = '#f80000';
    this.sampleMarksArray = [];
    this.patternsArray = [];
    this.afibEventsArray = [];
    this.specifySampleMark = null;
    this.specifyPattern = null;
    this.isDrawingSampleMark = false;
  };

  EcgView.prototype.draw = function (offsetX: any) {
    // *: Clear old chart
    this.canvasChart.clear();

    // *: 3 main lines
    this.drawAllChartLine(offsetX);

    // TODO: Prevent selected mark/pattern when scrolling
    // *: Sample mark lines
    if (!this.specifySampleMark) {
      _.forEach(this.sampleMarksArray, (sampleMark) => {
        sampleMark.drawOneSampleMark(offsetX, 'blue');
      });
    } else {
      this.drawSpecifySampleMark(offsetX);
    }

    // *: Patterns
    if (!this.specifyPattern) {
      _.forEach(this.patternsArray, (pattern) => {
        pattern.drawOnePattern(offsetX);
      });
    } else {
      this.drawSpecifyPattern(offsetX);
    }

    // *: AFib events
    _.forEach(this.afibEventsArray, (afibEvent) => {
      afibEvent.drawOneAFibEvent(offsetX);
    });
  };

  EcgView.prototype.drawAllChartLine = function (offsetX: any) {
    const { sampleLength, sampleRange } = this.config;
    const start = offsetX;
    const end =
      sampleRange - 1 + offsetX <= sampleLength ? sampleRange - 1 + offsetX : sampleLength - 1;
    this.ctxChart.beginPath();
    this.ctxChart.strokeStyle = '#000';
    _.forEach(this.pixelSamples, (displayedSamples) => {
      for (let j = start; j < end; j += 1) {
        this.ctxChart.moveTo(
          displayedSamples[j].x - displayedSamples[start].x,
          displayedSamples[j].y,
        );
        this.ctxChart.lineTo(
          displayedSamples[j + 1].x - displayedSamples[start].x,
          displayedSamples[j + 1].y,
        );
      }
    });
    this.ctxChart.stroke();
    this.ctxChart.closePath();
  };

  EcgView.prototype.drawSampleMark = function (offsetX: any, sampleMark: any) {
    // TODO: Handle duplicate line
    // const startSample = offsetX;
    // const endSample = startSample + this.config.sampleRange;

    // oxlint-disable-next-line import/no-named-as-default-member
    const sampleMarkLine = new SampleMark.SampleMark(
      this.canvasChart,
      this.verticalChannelPlacement,
      this.config,
      this.displayedChannelsArr,
      this.pixelSamples,
      sampleMark,
    );
    this.sampleMarksArray.push(sampleMarkLine);
    sampleMarkLine.drawOneSampleMark(offsetX, this.sampleMarkColor);
    this.specifySampleMark = sampleMarkLine;
    // this.isDrawnSelectedSampleMark = true;
  };

  EcgView.prototype.drawSpecifySampleMark = function (offsetX: any) {
    _.forEach(this.sampleMarksArray, (sampleMark) => {
      if (sampleMark !== this.specifySampleMark) {
        // draw other sample mark
        sampleMark.drawOneSampleMark(offsetX, 'blue');
      }
    });

    // *: Draw specify sample mark
    this.specifySampleMark.drawOneSampleMark(offsetX, this.sampleMarkColor);
  };

  EcgView.prototype.selectMark = function (
    clickedOffsetX: any,
    points: any,
    clickedChannelIndex: any,
  ) {
    const realChannelIndex = this.displayedChannelsArr[clickedChannelIndex];
    /**
     * Selects the sample marks on the channel that was clicked. Filters this.sampleMarksArray for entries whose channelIndex equals realChannelIndex.
     *
     * @returns The sample marks on the clicked channel.
     */
    const clickedSampleMarksArray = _.filter(
      this.sampleMarksArray,
      (x) => x.channelIndex === realChannelIndex,
    );
    const filteredSampleMark = [];

    // *: Find selected mark
    if (clickedSampleMarksArray.length > 0) {
      for (let i = 0; i < clickedSampleMarksArray.length; i += 1) {
        const { startSample, endSample } = clickedSampleMarksArray[i];
        if (
          clickedOffsetX >= startSample - 10 &&
          clickedOffsetX <= startSample + 10 &&
          points.y >= clickedSampleMarksArray[i].startY &&
          points.y <= clickedSampleMarksArray[i].endY
        ) {
          // click startY
          // if (!_.includes(filteredSampleMark, clickedSampleMarksArray[i])) {
          filteredSampleMark.push(clickedSampleMarksArray[i]);
          // }
        } else if (
          clickedOffsetX >= endSample - 10 &&
          clickedOffsetX <= endSample + 10 &&
          points.y >= clickedSampleMarksArray[i].startY &&
          points.y <= clickedSampleMarksArray[i].endY
        ) {
          // click endY
          // if (!_.includes(filteredSampleMark, clickedSampleMarksArray[i])) {
          filteredSampleMark.push(clickedSampleMarksArray[i]);
          // }
        } else if (clickedOffsetX >= startSample && clickedOffsetX <= endSample) {
          // click inside
          for (let k = clickedOffsetX - 10; k < clickedOffsetX + 10; k += 1) {
            if (
              points.y >= this.pixelSamples[clickedChannelIndex][k].y - 10 &&
              points.y <= this.pixelSamples[clickedChannelIndex][k].y + 10
            ) {
              // if (!_.includes(filteredSampleMark, clickedSampleMarksArray[i])) {
              filteredSampleMark.push(clickedSampleMarksArray[i]);
              // }
            }
          }
        }
      }
    }

    // *: Set flag
    if (!filteredSampleMark.length) {
      this.specifySampleMark = null;
    } else if (filteredSampleMark[filteredSampleMark.length - 1] !== this.specifySampleMark) {
      this.specifySampleMark = filteredSampleMark[filteredSampleMark.length - 1];
      this.isDrawnSelectedSampleMark = false;
    } else {
      this.isDrawnSelectedSampleMark = true;
    }
  };

  EcgView.prototype.drawSelectedMark = function (offsetX: any) {
    if (this.specifySampleMark && !this.isDrawnSelectedSampleMark) {
      // *: selected sample mark
      this.isDrawnSelectedSampleMark = true;

      this.canvasChart.clear();

      this.drawAllChartLine(offsetX);

      _.forEach(this.patternsArray, (pattern) => {
        pattern.drawOnePattern(offsetX);
      });

      _.forEach(this.afibEventsArray, (afibEvent) => {
        afibEvent.drawOneAFibEvent(offsetX);
      });

      if (this.specifySampleMark.startSample > this.specifySampleMark.endSample) {
        const tmp = this.specifySampleMark.startSample;
        this.specifySampleMark.startSample = this.specifySampleMark.endSample;
        this.specifySampleMark.endSample = tmp;
      }
      this.drawSpecifySampleMark(offsetX);
    } else if (!this.specifySampleMark && !this.specifyPattern) {
      this.draw(offsetX);
    }
  };

  // EcgView.prototype.editSampleMark = function (offsetX, offsetXVLine) {
  //   if (this.isClickFirstVLine) {
  //     this.specifySampleMark.startSample += offsetXVLine;
  //   } else {
  //     this.specifySampleMark.endSample += offsetXVLine;
  //   }
  //   this.specifySampleMark.firstVLineIndex = this.specifySampleMark.startSample;
  //   this.specifySampleMark.lastVLineIndex = this.specifySampleMark.endSample;
  //   this.specifySampleMark.sampleMarkRange = this.specifySampleMark.endSample - this.specifySampleMark.startSample;

  //   this.draw(offsetX);
  // };

  EcgView.prototype.drawPattern = function (offsetX: any, specifyPattern: any) {
    // oxlint-disable-next-line import/no-named-as-default-member
    const pattern = new Pattern.Pattern(
      this.canvasChart,
      this.config,
      this.displayedChannelsArr,
      this.pixelSamples,
      specifyPattern,
    );
    pattern.drawOnePattern(offsetX, this.patternColor);
    this.specifyPattern = pattern;
    this.patternsArray.push(pattern);
  };

  EcgView.prototype.drawSpecifyPattern = function (offsetX: any, color = this.patternColor) {
    _.forEach(this.patternsArray, (pattern) => {
      if (pattern !== this.specifyPattern) {
        // *: Draw other pattern
        pattern.drawOnePattern(offsetX);
      }
    });

    // *: Draw specify pattern
    this.specifyPattern.drawOnePattern(offsetX, color);
  };

  EcgView.prototype.selectPattern = function (
    clickedOffsetX: any,
    points: any,
    clickedChannelIndex: any,
  ) {
    const realChannelIndex = this.displayedChannelsArr[clickedChannelIndex];
    /**
     * Selects the ECG patterns on the channel that was clicked. Filters this.patternsArray for entries whose channelIndex equals realChannelIndex.
     *
     * @returns The patterns on the clicked channel.
     */
    const clickedPatternArray = _.filter(
      this.patternsArray,
      (x) => x.channelIndex === realChannelIndex,
    );
    const filteredPattern = [];

    // *: Find selected pattern
    if (clickedPatternArray.length > 0) {
      for (let i = 0; i < clickedPatternArray.length; i += 1) {
        const { startSample, endSample } = clickedPatternArray[i];

        if (clickedOffsetX >= startSample && clickedOffsetX <= endSample) {
          // *: Click inside
          for (let k = clickedOffsetX - 10; k < clickedOffsetX + 10; k += 1) {
            if (
              points.y >= this.pixelSamples[clickedChannelIndex][k].y - 10 &&
              points.y <= this.pixelSamples[clickedChannelIndex][k].y + 10
            ) {
              if (!_.includes(filteredPattern, clickedPatternArray[i])) {
                filteredPattern.push(clickedPatternArray[i]);
              }
            }
          }
        }
      }
    }

    if (!filteredPattern.length) {
      this.specifyPattern = null;
    } else if (filteredPattern[filteredPattern.length - 1] !== this.specifyPattern) {
      this.specifyPattern = filteredPattern[filteredPattern.length - 1];
      this.isDrawnSelectedPattern = false;
    } else {
      this.isDrawnSelectedPattern = true;
    }
  };

  EcgView.prototype.drawSelectedPattern = function (offsetX: any) {
    if (this.specifyPattern && !this.isDrawnSelectedPattern) {
      // *: Selected pattern
      this.isDrawnSelectedPattern = true;

      this.canvasChart.clear();

      this.drawAllChartLine(offsetX);

      _.forEach(this.sampleMarksArray, (sampleMark) => {
        sampleMark.drawOneSampleMark(offsetX, 'blue');
      });

      _.forEach(this.afibEventsArray, (afibEvent) => {
        afibEvent.drawOneAFibEvent(offsetX);
      });

      if (this.specifyPattern.startSample > this.specifyPattern.endSample) {
        const tmp = this.specifyPattern.startSample;
        this.specifyPattern.startSample = this.specifyPattern.endSample;
        this.specifyPattern.endSample = tmp;
      }
      this.drawSpecifyPattern(offsetX);
    } else if (!this.specifyPattern && !this.specifySampleMark) {
      this.draw(offsetX);
    }
  };

  EcgView.prototype.changePatternColor = function (color: any, offsetX: any) {
    if (this.specifyPattern) {
      this.canvasChart.clear();

      this.drawAllChartLine(offsetX);

      _.forEach(this.sampleMarksArray, (sampleMark) => {
        sampleMark.drawOneSampleMark(offsetX, 'blue');
      });

      this.specifyPattern.changeColor(color);
      this.drawSpecifyPattern(offsetX, color);
    }
  };

  EcgView.prototype.deleteMark = function () {
    if (this.specifySampleMark) {
      // *: Delete sample mark
      _.remove(this.sampleMarksArray, (x) => x === this.specifySampleMark);
      this.specifySampleMark = null;
    } else if (this.specifyPattern) {
      // *: Delete pattern
      _.remove(this.patternsArray, (x) => x === this.specifyPattern);
      this.specifyPattern = null;
    }
  };

  EcgView.prototype.update = function (
    pixelSamples: any,
    config: any,
    displayedChannelsArr: any,
    verticalChannelPlacement: any,
  ) {
    this.pixelSamples = pixelSamples;
    this.config = config;
    this.displayedChannelsArr = displayedChannelsArr;
    this.verticalChannelPlacement = verticalChannelPlacement;

    // *: Update sample marks
    _.forEach(this.sampleMarksArray, (sampleMark) => {
      sampleMark.update(
        this.pixelSamples,
        this.config,
        this.displayedChannelsArr,
        this.verticalChannelPlacement,
      );
    });

    // *: Update patterns
    _.forEach(this.patternsArray, (pattern) => {
      pattern.update(
        this.pixelSamples,
        this.config,
        this.displayedChannelsArr,
        this.verticalChannelPlacement,
      );
    });

    // *: Update AFib events
    _.forEach(this.afibEventsArray, (afibEvent) => {
      afibEvent.update(this.pixelSamples, this.config, this.displayedChannelsArr);
    });
  };

  EcgView.prototype.applyAI = function (isAppliedAI: any, offsetX: any, afibEventsArray: any) {
    this.isAppliedAI = isAppliedAI;
    this.afibEventsArray = [];
    if (isAppliedAI) {
      _.forEach(afibEventsArray, (specifyAFibEvent) => {
        // oxlint-disable-next-line import/no-named-as-default-member
        const afibEvent = new AFibEvent.AFibEvent(
          this.canvasChart,
          this.config,
          this.displayedChannelsArr,
          this.pixelSamples,
          specifyAFibEvent,
        );
        this.afibEventsArray.push(afibEvent);
      });
    }
    this.draw(offsetX);
  };

  // EcgView.prototype.updateSpecifySampleMark = function () {
  //   const start = this.specifySampleMark.startSample;
  //   const end = this.specifySampleMark.endSample;
  //   this.specifySampleMark.startSample = Math.min(start, end);
  //   this.specifySampleMark.endSample = Math.max(start, end);
  //   this.specifySampleMark.firstVLineIndex = this.specifySampleMark.startSample;
  //   this.specifySampleMark.lastVLineIndex = this.specifySampleMark.endSample;
  //   this.specifySampleMark.sampleMarkRange = this.specifySampleMark.endSample - this.specifySampleMark.startSample;
  //   this.isClickFirstVLine = false;
  //   this.isClickLastVLine = false;
  // };

  EcgView.prototype.updateData = function () {
    this.specifySampleMark = null;
    this.specifyPattern = null;
    this.specifyAFibEvent = null;
    this.sampleMarksArray = [];
    this.patternsArray = [];
    this.afibEventsArray = [];
  };

  EcgView.prototype.drawPolyline = function (points: any, stroke: any, strokeWidth: any) {
    return new fabric.Polyline(points, {
      stroke,
      fill: '',
      strokeWidth,
      strokeLineJoin: 'round',
      strokeLineCap: 'round',
    });
  };

  EcgView.prototype.deSelectPartly = function (annotation: any, resetSelected: any) {
    // *: De-select annotation
    let { selectedObj } = annotation;
    if (resetSelected) {
      if (selectedObj) {
        selectedObj = annotation.selectedObj;
        selectedObj.deselect();
      }
    } else if (selectedObj) {
      selectedObj.select();
    }
  };

  EcgView.prototype.exportPartly = function (
    titleChart: any,
    markers: any,
    annotation: any,
    gridBackGround: any,
    canvasObject: any,
    start: any,
    isAllStrip = false,
  ) {
    // *: Update partly (to export)
    titleChart.draw(start, isAllStrip);
    markers.draw(start);
    annotation.scroll(start, this.displayedChannelsArr);

    let eventPositionAnnotation;
    _.forEach(annotation.annoArr, (anno) => {
      if (anno.type === ANNOTATION_TYPE.BCC) {
        anno.setTextForExport();
      }

      // *: Hide event position when exporting image
      if (anno.type === ANNOTATION_TYPE.EVENT_POSITION) {
        anno.isVisibility(false);
        eventPositionAnnotation = anno;
      }
    });

    // *: Export svg background
    const svgbg = gridBackGround.export();

    // *: Export svg object
    const svgObject = canvasObject.toSVG(
      {
        viewBox: {
          x: 0,
          y: 0,
          width: 945,
          height: 250,
        },
      },
      (e: any) => (e.includes('hidden') ? '' : e),
    );

    // *: Re-show event position after exporting image completely
    if (eventPositionAnnotation) {
      eventPositionAnnotation.isVisibility(true);
    }

    return { svgbg, svgObject };
  };

  EcgView.prototype.exportAll = function (
    titleChart: any,
    markers: any,
    annotation: any,
    gridBackGround: any,
    canvasObject: any,
    isAllStrip = false,
  ) {
    const { sampleRange, sampleLength } = this.config;

    let isDrawAll = false;
    for (let i = 0; i < this.sampleMarksArray.length; i += 1) {
      if (!_.includes(this.displayedChannelsArr, this.sampleMarksArray[i].channelIndex)) {
        isDrawAll = true;
      } else {
        isDrawAll = false;
        break;
      }
    }

    if (this.sampleMarksArray.length > 0 && !isDrawAll) {
      // *: Have sample marks
      const svgMain = [];

      // *: Filter sample marks are in displayed line to draw
      /**
       * Selects the sample marks whose channelIndex is among the currently displayed channels. Filters this.sampleMarksArray with lodash includes against displayedChannelsArr.
       *
       * @returns The sample marks belonging to displayed channels.
       */
      const inlineSampleMarkArray = _.filter(this.sampleMarksArray, (x) =>
        _.includes(this.displayedChannelsArr, x.channelIndex),
      );

      for (let j = 0; j < inlineSampleMarkArray.length; j += 1) {
        let { startSample } = inlineSampleMarkArray[j];
        let endSample =
          startSample + sampleRange - 1 < sampleLength
            ? startSample + sampleRange - 1
            : sampleLength - 1;

        if (inlineSampleMarkArray[j].sampleMarkRange <= sampleRange) {
          // *: De-select partly
          this.deSelectPartly(annotation, true);

          // *: Export svg canvas object
          const { svgbg, svgObject } = this.exportPartly(
            titleChart,
            markers,
            annotation,
            gridBackGround,
            canvasObject,
            startSample,
            isAllStrip,
          );

          // *: Export svg canvas chart
          const svg = this.exportSVG(startSample, endSample);

          // *: Create svg main
          svgMain.push(addSVGs([svgbg, svg, svgObject]));

          // *: Undo selected partly
          this.deSelectPartly(annotation, false);
        } else {
          // *: Calculate number of window
          const windowCounter = Math.ceil(inlineSampleMarkArray[j].sampleMarkRange / sampleRange);

          // *: Devide many segments
          for (let l = 0; l < windowCounter; l += 1) {
            this.deSelectPartly(annotation, true);

            const { svgbg, svgObject } = this.exportPartly(
              titleChart,
              markers,
              annotation,
              gridBackGround,
              canvasObject,
              startSample,
              isAllStrip,
            );
            const svg = this.exportSVG(startSample, endSample);
            svgMain.push(addSVGs([svgbg, svg, svgObject]));

            this.deSelectPartly(annotation, false);

            // *: Update start, end
            startSample = endSample + 1;
            endSample =
              startSample + sampleRange - 1 < sampleLength
                ? startSample + sampleRange - 1
                : sampleLength - 1;
          }
        }
      }

      return svgMain;
    }

    const svgMain = [];

    for (let i = 0; i < sampleLength; i += sampleRange) {
      const start = i;
      const end =
        start + sampleRange - 1 <= sampleLength - 1 ? start + sampleRange - 1 : sampleLength - 1;

      this.deSelectPartly(annotation, true);

      const { svgbg, svgObject } = this.exportPartly(
        titleChart,
        markers,
        annotation,
        gridBackGround,
        canvasObject,
        start,
        isAllStrip,
      );
      const svg = this.exportSVG(start, end);

      svgMain.push(addSVGs([svgbg, svg, svgObject]));

      this.deSelectPartly(annotation, false);

      // start = end;
      // end = start + sampleRange;
    }

    return svgMain;
  };

  EcgView.prototype.exportSVG = function (startSample: any, endSample: any): any {
    // *: Create chart array points
    const arrayLinePointsBlack = [];
    const arrayLinePointsBlue = [];
    const arrayPatternPoints = [];
    const arrayAFibEventPoints = [];
    for (let i = 0; i < this.displayedChannelsArr.length; i += 1) {
      /**
       * Selects the sample marks belonging to the channel currently being drawn. Filters this.sampleMarksArray for entries whose channelIndex matches displayedChannelsArr[i].
       *
       * @returns The sample marks for the current channel.
       */
      const inlineSampleMarkArray = _.filter(
        this.sampleMarksArray,
        (x) => x.channelIndex === this.displayedChannelsArr[i],
      );
      if (inlineSampleMarkArray.length > 0) {
        let startEndArray = [];
        for (let j = 0; j < inlineSampleMarkArray.length; j += 1) {
          startEndArray.push({
            start: inlineSampleMarkArray[j].startSample,
            end: inlineSampleMarkArray[j].endSample,
          });
          const arraySampleMarkLine = [];
          for (let k = startSample; k <= endSample; k += 1) {
            if (
              k >= inlineSampleMarkArray[j].startSample &&
              k <= inlineSampleMarkArray[j].endSample
            ) {
              if (
                k === inlineSampleMarkArray[j].startSample || // *: First vertical line
                k === inlineSampleMarkArray[j].endSample
              ) {
                // *: Last vertical line
                const arrayVLine = [];
                for (
                  let l = inlineSampleMarkArray[j].startY;
                  l <= inlineSampleMarkArray[j].endY;
                  l += 1
                ) {
                  const x = this.pixelSamples[i][k].x - this.pixelSamples[i][startSample].x;
                  arrayVLine.push(
                    new fabric.Point(
                      x === this.config.width ? x - this.ctxChart.lineWidth / 2 : x,
                      l,
                    ),
                  );
                }
                arrayLinePointsBlue.push({ points: arrayVLine, strokeStyle: 'blue' });
              } else {
                // *: Sample mark line
                arraySampleMarkLine.push(
                  new fabric.Point(
                    this.pixelSamples[i][k].x - this.pixelSamples[i][startSample].x,
                    this.pixelSamples[i][k].y,
                  ),
                );
              }
            }
          }
          if (arraySampleMarkLine.length > 0) {
            arrayLinePointsBlue.push({ points: arraySampleMarkLine, strokeStyle: 'blue' });
          }
        }

        /**
         * Selects the ECG patterns belonging to the channel currently being drawn. Filters this.patternsArray for entries whose channelIndex matches displayedChannelsArr[i].
         *
         * @returns The patterns for the current channel.
         */
        const inlinePatternArray = _.filter(
          this.patternsArray,
          (x) => x.channelIndex === this.displayedChannelsArr[i],
        );
        if (inlinePatternArray.length > 0) {
          // *: Have pattern
          for (let t = 0; t < inlinePatternArray.length; t += 1) {
            startEndArray.push({
              start: inlinePatternArray[t].startSample,
              end: inlinePatternArray[t].endSample,
            });
            const arrayPattern = [];
            for (let o = startSample; o <= endSample; o += 1) {
              if (o >= inlinePatternArray[t].startSample && o <= inlinePatternArray[t].endSample) {
                arrayPattern.push(
                  new fabric.Point(
                    this.pixelSamples[i][o].x - this.pixelSamples[i][startSample].x,
                    this.pixelSamples[i][o].y,
                  ),
                );
              }
            }
            if (arrayPattern.length > 0) {
              arrayPatternPoints.push({
                points: arrayPattern,
                strokeStyle: inlinePatternArray[t].color,
              });
            }
          }
        }

        /**
         * Selects the AFib events belonging to the channel currently being drawn. Filters this.afibEventsArray for entries whose channelIndex matches displayedChannelsArr[i].
         *
         * @returns The AFib events for the current channel.
         */
        const inlineAFibEventArray = _.filter(
          this.afibEventsArray,
          (x) => x.channelIndex === this.displayedChannelsArr[i],
        );
        if (inlineAFibEventArray.length > 0) {
          // *: Have AFib event
          for (let t = 0; t < inlineAFibEventArray.length; t += 1) {
            startEndArray.push({
              start: inlineAFibEventArray[t].startSample,
              end: inlineAFibEventArray[t].endSample,
            });
            const arrayAFibEvent = [];
            for (let o = startSample; o <= endSample; o += 1) {
              if (
                o >= inlineAFibEventArray[t].startSample &&
                o <= inlineAFibEventArray[t].endSample
              ) {
                arrayAFibEvent.push(
                  new fabric.Point(
                    this.pixelSamples[i][o].x - this.pixelSamples[i][startSample].x,
                    this.pixelSamples[i][o].y,
                  ),
                );
              }
            }
            if (arrayAFibEvent.length > 0) {
              arrayAFibEventPoints.push({
                points: arrayAFibEvent,
                strokeStyle: inlineAFibEventArray[t].color,
              });
            }
          }
        }

        // *: Other line between sample marks
        const otherFirstLine = [];
        const otherLastLine = [];
        const otherLine = [];
        startEndArray = _.orderBy(startEndArray, ['start'], ['asc']);
        for (let m = 0; m < startEndArray.length; m += 1) {
          if (m === 0) {
            if (startEndArray[m].start > startSample) {
              for (let n = startSample; n <= startEndArray[m].start; n += 1) {
                otherFirstLine.push(
                  new fabric.Point(
                    this.pixelSamples[i][n].x - this.pixelSamples[i][startSample].x,
                    this.pixelSamples[i][n].y,
                  ),
                );
              }
            }
          }

          if (m === startEndArray.length - 1) {
            if (startEndArray[m].end < endSample) {
              for (let g = startEndArray[m].end; g <= endSample; g += 1) {
                otherLastLine.push(
                  new fabric.Point(
                    this.pixelSamples[i][g].x - this.pixelSamples[i][startSample].x,
                    this.pixelSamples[i][g].y,
                  ),
                );
              }
            }
          }

          if (m !== startEndArray.length - 1) {
            const array = [];
            for (let h = startEndArray[m].end; h <= startEndArray[m + 1].start; h += 1) {
              array.push(
                new fabric.Point(
                  this.pixelSamples[i][h].x - this.pixelSamples[i][startSample].x,
                  this.pixelSamples[i][h].y,
                ),
              );
            }
            if (array.length > 0) {
              otherLine.push(array);
            }
          }
        }

        if (otherFirstLine.length > 0) {
          arrayLinePointsBlack.push({ points: otherFirstLine, strokeStyle: '#000' });
        }
        if (otherLastLine.length > 0) {
          arrayLinePointsBlack.push({ points: otherLastLine, strokeStyle: '#000' });
        }
        _.forEach(otherLine, (element) => {
          arrayLinePointsBlack.push({ points: element, strokeStyle: '#000' });
        });
      } else {
        // *: Not have sample mark
        // *: Check to have pattern or not
        /**
         * Selects the ECG patterns belonging to the channel currently being drawn. Filters this.patternsArray for entries whose channelIndex matches displayedChannelsArr[i].
         *
         * @returns The patterns for the current channel.
         */
        const inlinePatternArray = _.filter(
          this.patternsArray,
          (x) => x.channelIndex === this.displayedChannelsArr[i],
        );

        // *: Check to have AFib event or not
        /**
         * Selects the AFib events belonging to the channel currently being drawn. Filters this.afibEventsArray for entries whose channelIndex matches displayedChannelsArr[i].
         *
         * @returns The AFib events for the current channel.
         */
        const inlineAFibEventArray = _.filter(
          this.afibEventsArray,
          (x) => x.channelIndex === this.displayedChannelsArr[i],
        );

        if (inlinePatternArray.length > 0 || inlineAFibEventArray.length > 0) {
          let startEndArray = [];
          for (let t = 0; t < inlinePatternArray.length; t += 1) {
            startEndArray.push({
              start: inlinePatternArray[t].startSample,
              end: inlinePatternArray[t].endSample,
            });
            const arrayPattern = [];
            for (let o = startSample; o <= endSample; o += 1) {
              if (o >= inlinePatternArray[t].startSample && o <= inlinePatternArray[t].endSample) {
                arrayPattern.push(
                  new fabric.Point(
                    this.pixelSamples[i][o].x - this.pixelSamples[i][startSample].x,
                    this.pixelSamples[i][o].y,
                  ),
                );
              }
            }
            if (arrayPattern.length > 0) {
              arrayPatternPoints.push({
                points: arrayPattern,
                strokeStyle: inlinePatternArray[t].color,
              });
            }
          }

          for (let t = 0; t < inlineAFibEventArray.length; t += 1) {
            startEndArray.push({
              start: inlineAFibEventArray[t].startSample,
              end: inlineAFibEventArray[t].endSample,
            });
            const arrayAFibEvent = [];
            for (let o = startSample; o <= endSample; o += 1) {
              if (
                o >= inlineAFibEventArray[t].startSample &&
                o <= inlineAFibEventArray[t].endSample
              ) {
                arrayAFibEvent.push(
                  new fabric.Point(
                    this.pixelSamples[i][o].x - this.pixelSamples[i][startSample].x,
                    this.pixelSamples[i][o].y,
                  ),
                );
              }
            }
            if (arrayAFibEvent.length > 0) {
              arrayAFibEventPoints.push({
                points: arrayAFibEvent,
                strokeStyle: inlineAFibEventArray[t].color,
              });
            }
          }

          // *: Other line between patterns
          startEndArray = _.orderBy(startEndArray, ['start'], ['asc']);

          if (startEndArray.length === 1) {
            const otherFirstLine = [];
            const otherLastLine = [];
            for (let n = startSample; n <= startEndArray[0].start; n += 1) {
              otherFirstLine.push(
                new fabric.Point(
                  this.pixelSamples[i][n].x - this.pixelSamples[i][startSample].x,
                  this.pixelSamples[i][n].y,
                ),
              );
            }

            for (let g = startEndArray[0].end; g <= endSample; g += 1) {
              otherLastLine.push(
                new fabric.Point(
                  this.pixelSamples[i][g].x - this.pixelSamples[i][startSample].x,
                  this.pixelSamples[i][g].y,
                ),
              );
            }

            if (otherFirstLine.length > 0) {
              arrayLinePointsBlack.push({ points: otherFirstLine, strokeStyle: '#000' });
            }
            if (otherLastLine.length > 0) {
              arrayLinePointsBlack.push({ points: otherLastLine, strokeStyle: '#000' });
            }
          } else {
            const otherFirstLine = [];
            const otherLastLine = [];
            const otherLine = [];

            for (let m = 0; m < startEndArray.length; m += 1) {
              if (m === 0) {
                if (startEndArray[m].start > startSample) {
                  for (let n = startSample; n <= startEndArray[m].start; n += 1) {
                    otherFirstLine.push(
                      new fabric.Point(
                        this.pixelSamples[i][n].x - this.pixelSamples[i][startSample].x,
                        this.pixelSamples[i][n].y,
                      ),
                    );
                  }
                }
              }

              if (m === startEndArray.length - 1) {
                if (startEndArray[m].end < endSample) {
                  for (let g = startEndArray[m].end; g <= endSample; g += 1) {
                    otherLastLine.push(
                      new fabric.Point(
                        this.pixelSamples[i][g].x - this.pixelSamples[i][startSample].x,
                        this.pixelSamples[i][g].y,
                      ),
                    );
                  }
                }
              }

              if (m !== startEndArray.length - 1) {
                const array = [];
                for (let h = startEndArray[m].end; h <= startEndArray[m + 1].start; h += 1) {
                  array.push(
                    new fabric.Point(
                      this.pixelSamples[i][h].x - this.pixelSamples[i][startSample].x,
                      this.pixelSamples[i][h].y,
                    ),
                  );
                }

                if (array.length > 0) {
                  otherLine.push(array);
                }
              }
            }

            if (otherFirstLine.length > 0) {
              arrayLinePointsBlack.push({ points: otherFirstLine, strokeStyle: '#000' });
            }
            if (otherLastLine.length > 0) {
              arrayLinePointsBlack.push({ points: otherLastLine, strokeStyle: '#000' });
            }
            _.forEach(otherLine, (element) => {
              arrayLinePointsBlack.push({ points: element, strokeStyle: '#000' });
            });
          }
        } else {
          const arrayLine = [];
          for (let l = startSample; l <= endSample; l += 1) {
            arrayLine.push(
              new fabric.Point(
                this.pixelSamples[i][l].x - this.pixelSamples[i][startSample].x,
                this.pixelSamples[i][l].y,
              ),
            );
          }
          if (arrayLine.length > 0) {
            arrayLinePointsBlack.push({ points: arrayLine, strokeStyle: '#000' });
          }
        }
      }
    }

    // *: Create chart svg path
    const pathChart: any = [];
    _.forEach(arrayLinePointsBlack, (element) => {
      const { points, strokeStyle } = element;
      if (points.length > 0) {
        const pl = this.drawPolyline(points, strokeStyle, this.lineWidthExport);
        this.canvasChart.add(pl);
        pathChart.push(pl);
      }
    });

    _.forEach(arrayLinePointsBlue, (element) => {
      const { points, strokeStyle } = element;
      if (points.length > 0) {
        const pl = this.drawPolyline(points, strokeStyle, this.lineWidthExport);
        this.canvasChart.add(pl);
        pathChart.push(pl);
      }
    });

    _.forEach(arrayPatternPoints, (element) => {
      const { points, strokeStyle } = element;
      if (points.length > 0) {
        const pl = this.drawPolyline(points, strokeStyle, this.lineWidthExport);
        this.canvasChart.add(pl);
        pathChart.push(pl);
      }
    });

    _.forEach(arrayAFibEventPoints, (element) => {
      const { points, strokeStyle } = element;
      if (points.length > 0) {
        const pl = this.drawPolyline(points, strokeStyle, this.lineWidthExport);
        this.canvasChart.add(pl);
        pathChart.push(pl);
      }
    });

    // *: Export svg chart
    const svg = this.canvasChart.toSVG(
      {
        viewBox: {
          x: 0,
          y: 0,
          width: 946,
          height: 250,
        },
      },
      (e: any) => (e.includes('hidden') ? '' : e),
    );

    // *: Remove line
    _.forEach(pathChart, (element) => {
      this.canvasChart.remove(element);
    });

    return svg;
  };

  EcgView.prototype.importMark = function (offsetX: any, specifyMark: any) {
    if (specifyMark.type === ANNOTATION_TYPE.SAMPLE_MARK) {
      // oxlint-disable-next-line import/no-named-as-default-member
      const sampleMark = new SampleMark.SampleMark(
        this.canvasChart,
        this.verticalChannelPlacement,
        this.config,
        this.displayedChannelsArr,
        this.pixelSamples,
        specifyMark,
      );
      sampleMark.drawOneSampleMark(offsetX, 'blue');
      this.sampleMarksArray.push(sampleMark);
    } else if (specifyMark.type === ANNOTATION_TYPE.PATTERN) {
      // oxlint-disable-next-line import/no-named-as-default-member
      const pattern = new Pattern.Pattern(
        this.canvasChart,
        this.config,
        this.displayedChannelsArr,
        this.pixelSamples,
        specifyMark,
      );
      pattern.color = specifyMark.color;
      pattern.drawOnePattern(offsetX, pattern.color);
      this.patternsArray.push(pattern);
    } else if (this.isAppliedAI) {
      // oxlint-disable-next-line import/no-named-as-default-member
      const afibEvent = new AFibEvent.AFibEvent(
        this.canvasChart,
        this.config,
        this.displayedChannelsArr,
        this.pixelSamples,
        specifyMark,
      );
      afibEvent.drawOneAFibEvent(offsetX);
      this.afibEventsArray.push(afibEvent);
    }
  };

  EcgView.prototype.getJSONObject = function (): any {
    const objArr: any = [];
    _.forEach(this.sampleMarksArray, (sampleMark) => {
      objArr.push(sampleMark.getJSONObject());
    });
    _.forEach(this.patternsArray, (pattern) => {
      objArr.push(pattern.getJSONObject());
    });
    if (this.isAppliedAI) {
      _.forEach(this.afibEventsArray, (afibEvent) => {
        objArr.push(afibEvent.getJSONObject());
      });
    }
    return objArr;
  };
})();

export { EcgView };
export default { EcgView };
